import { ReactComponent as OutlineChevronDown } from "assets/svg/outline-chevron-down.svg";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { Form } from "react-bootstrap";
import Select from "react-select";
import styles from "./CustomSelect.module.scss";

function getBorderColor(showAsInvalid: boolean, disabledStyleForV2: boolean) {
  if (showAsInvalid) {
    return "#FF0000";
  } else if (disabledStyleForV2) {
    return "#E7E7E7";
  } else {
    return "inherit";
  }
}

const CustomGroupHeading = (props) => {
  const { groupId } = props.data;
  return groupId !== 0 ? <hr className={styles["custom-select__hr"]} /> : null;
};

const GroupHeadingV2 = (props) => {
  if (props.id.endsWith("group-0-heading")) {
    return null;
  }
  return <div className={styles["group-heading-v2"]} />;
};

const DropdownIndicator = (props) => {
  return (
    <div className={styles["indicator-container"]}>
      <OutlineChevronDown />
    </div>
  );
};

const CustomSelect = ({
  useNotesAndFormsV2Styles,
  ...props
}: {
  [x: string]: any;
  useNotesAndFormsV2Styles?: boolean;
}) => {
  const { defaultValue, value, required, isMulti, key } = props;
  const { isPhonePortrait } = usePhonePortraitContext();

  const selectStyles = {
    control: (styles) => ({
      ...styles,
      borderLeft: !isPhonePortrait ? undefined : "none",
      borderRight: !isPhonePortrait ? undefined : "none",
      borderTop: !isPhonePortrait ? undefined : "none",
      borderRadius: !isPhonePortrait ? 4 : 0,
      backgroundColor: "white",
      borderColor: "#ADCCFF",
      fontSize: 14,
      color: "#828282",
      boxShadow: "none",
      minHeight: 40,
      maxHeight: 40,

      "&:hover": {
        borderColor: "#ADCCFF",
      },
    }),

    placeholder: (styles) => ({
      ...styles,
      color: "#BDBDBD",
      fontWeight: 400,
    }),

    menu: (styles) => ({
      ...styles,
      fontSize: 12,
      zIndex: 1000,
      // TODO: check if there's better method
      outline: "1px solid white",
      filter: "drop-shadow(0px 2px 6px rgba(189, 189, 189, 0.3))",
    }),

    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isSelected
        ? "#1778E1"
        : isFocused
        ? "#F3FAFF"
        : undefined,
      color: isSelected ? "#FFFFFF" : "#333333",
      "& span": {
        color: isSelected ? "#FFFFFF" : "#828282",
      },
    }),
  };

  const disabledStyleForV2 = props.disabled && useNotesAndFormsV2Styles;

  return (
    <div className={"position-relative w-100"}>
      <Form.Control
        tabIndex={-1}
        autoComplete="nope"
        style={{
          opacity: 1,
          width: "100%",
          height: "100%",
          position: "absolute",
          zIndex: 500,
          paddingLeft: 10,
          backgroundImage: "none",
          backgroundColor: "transparent",
          borderColor: getBorderColor(props.showAsInvalid, disabledStyleForV2),
          color: "rgba(255, 255, 255, 0)",
          pointerEvents: "none",
        }}
        value={
          defaultValue ||
          (isMulti ? [value?.map((el) => el.value)] : value?.value) ||
          ""
        }
        onChange={() => null}
        required={required}
      />
      <Select
        key={key}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator,
          GroupHeading: useNotesAndFormsV2Styles
            ? GroupHeadingV2
            : CustomGroupHeading,
        }}
        styles={selectStyles}
        className={"smoothed"}
        {...props}
        isDisabled={props.disabled}
      />
    </div>
  );
};

export default CustomSelect;
